export default "__VITE_ASSET__CLGlMbsx__"